import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-check-lists',
  templateUrl: './check-lists.component.html',
  styleUrls: ['./check-lists.component.css']
})
export class CheckListsComponent implements OnInit {
    public setting?: Setting;

    public itemsListChecks: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1297))[0];
    }

    private async loadChecks() {
        this.itemsListChecks = await this.datatask.Post(540);
    }

    private async init() {
        this.loadSetting();
        this.loadChecks();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    searchtext: string;
}
